__webpack_require__.p = "#{service:cdnUrl}/";